
import {React, useState, useContext, useEffect} from "react"
import{UserContext} from '../../context/userContext/userContext'
import { useStyle } from '../../context/styleContext/styleContext';
import axios from 'axios'
import {toast} from 'react-hot-toast'
import Button from '@mui/material/Button';
import ReactGA from 'react-ga4';
//import { FOCUSABLE_SELECTOR } from "@testing-library/user-event/dist/utils";
//import Terms from "../Terms/Terms"
import { Checkbox, TextField, FormGroup, FormControlLabel ,Box} from "@mui/material";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import UsersPanel from "./UsersPanel";
import AuthAttemptPanel from "./AuthAttemptPanel";
import WikiCommonsImage from "../../components/WikiCommonsImage/WikiCommonsImage";
import GainDemo from "../GainDemo/GainDemo";


export default function Admin(){

  const { user } = useContext(UserContext);
  const { style, setStyle } = useStyle();
  const [isPageLoading, setIsPageLoading] = useState(false);

  const [isPasswordModalOpen, setPasswordModalOpen] = useState(false);
  const openPasswordModal = () => setPasswordModalOpen(true);
  const closePasswordModal = () => setPasswordModalOpen(false);

  const [userPanelIsOpen, setUserPanelIsOpen] = useState(true);
  const [authAttemptPanelIsOpen, setAuthAttemptPanelIsOpen] = useState();

//   useEffect(() => {getAccountInfo();}, []); // pull list when screen loads
//   useEffect(() => {update();}, [])

  const [height, setHeight] = useState(window.innerHeight)
  const [width, setWidth] = useState(window.setWidth)

  useEffect(() => {
    function handleResize() {      
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
  }
  
    window.addEventListener('resize', handleResize)
  })
  const createSubscriptionType = async (e) => {

    const token = localStorage.getItem('token')

    try {
        const { data } = await axios.post('/admin/create_subscription_type');
        if (data.error) {
          toast.error(data.error);
        } else {
          toast.success("WOOHOO!")
        }
      } catch (error) {
        console.log(error);
      }

  }


    ReactGA.send({
        hitType:"pageview",
        page:"account",
        title:"account",
    })

    useEffect(() => {
    document.title = 'Parish Audio | State Of The Art State Of The Art Audio Processing | Admin';
    }, []);
  

    let userToken = ""
    if(localStorage.getItem('token'))
    {
        userToken = localStorage.getItem('token')
    }

    
    const openUserDisplay = async (e) => {

        setUserPanelIsOpen(true);
        setAuthAttemptPanelIsOpen(true);
        console.log("Open User Display")

    } 

    const openProductDisplay = async (e) => {

        setUserPanelIsOpen(false);
        console.log("Open User Display")

    } 

    const openAuthAttemptPanel = async (e) => {

      setUserPanelIsOpen(false);
      setAuthAttemptPanelIsOpen(true);
      console.log("Open User Display");


  } 
  

    return(
        <>          

        <div style={{minHeight:height - 130, backgroundColor:'black', borderTop:'0px', display:'flex', flexDirection:'row'}}>
            <Box sx={{width:'95%', maxWidth:'200px',m:1, backgroundColor:style.color1}}>
                <div style={{width:'100%', textAlign:'center', marginTop:'25px'}}>
                <Button onClick={openUserDisplay} sx={{
                          backgroundColor: style.color1,
                          color: style.color4,
                          border: `1px solid ${style.color2}`,
                          width:'95%',
                          margin:'auto',
                          filter:'brightness(1.05)',
                          boxShadow:10,
                          m:.5,
                          fontWeight:'bold',
                          fontSize:'.8rem',
                          "&:hover": { filter:'brightness(1.2)'},
                        }} >Users</Button>
            </div>
            <div style={{width:'100%',textAlign:'center', marginTop:'10px'}}>
                <Button onClick={openProductDisplay} sx={{
                          backgroundColor: style.color1,
                          color: style.color4,
                          border: `1px solid ${style.color2}`,
                          width:'95%',
                          margin:'auto',
                          filter:'brightness(1.05)',
                          boxShadow:10,
                          m:.5,
                          fontWeight:'bold',
                          fontSize:'.8rem',
                          "&:hover": { filter:'brightness(1.2)'},
                        }}>Products</Button>
            </div>
            <div style={{width:'100%',textAlign:'center', marginTop:'10px'}}>
                {/* <Button onClick={createSubscriptionType} sx={{
                          backgroundColor: style.color1,
                          color: style.color4,
                          border: `1px solid ${style.color2}`,
                          width:'95%',
                          margin:'auto',
                          filter:'brightness(1.05)',
                          boxShadow:10,
                          m:.5,
                          fontWeight:'bold',
                          fontSize:'.8rem',
                          "&:hover": { filter:'brightness(1.2)'},
                        }}>Subscription Type</Button> */}
            </div>
            <div style={{width:'100%',textAlign:'center', marginTop:'10px'}}>
                <Button onClick={openAuthAttemptPanel} sx={{
                          backgroundColor: style.color1,
                          color: style.color4,
                          border: `1px solid ${style.color2}`,
                          width:'95%',
                          margin:'auto',
                          filter:'brightness(1.05)',
                          boxShadow:10,
                          m:.5,
                          fontWeight:'bold',
                          fontSize:'.8rem',
                          "&:hover": { filter:'brightness(1.2)'},
                        }}>Auth attempts</Button>
            </div>
        </Box>
        <div style={{width:'100%', color:style.color4, margin:'auto', marginTop:'0px', backgroundColor:'black'}}>
            {userPanelIsOpen && (
                <UsersPanel />
            )}
            {authAttemptPanelIsOpen && (
                <AuthAttemptPanel />
            )}
            </div>
        </div>

<div>
  <GainDemo />
</div>

        
        </>

    )
}